import React from 'react';
import Header from './Header';

const Layout = ({ children }: { children: React.ReactElement }) => {
  return (
    <>
      <Header />
      <main className="app-main">{children}</main>
    </>
  );
};

export default Layout; 